<template>
    <div>
        <h1 style="text-align: center">Herzlich Willkommen bei DGHS</h1>

        <h4 style="margin-top: 50px" >Offene Rückmeldungen</h4>

        <member-table
            :data-url="'lifestatuses'"
            confirmation-table="true"
        ></member-table>
    </div>
</template>

<script>
    import MemberTable from "../components/MemberTable";

    export default {
        name: "Home",
        components: {
          MemberTable
        },
        mounted() {

        },
        methods: {

        },
        data() {
            return {

                formData: {
                    name: '',
                    email: ''
                },
                edit_id: false,
            }
        }

    }
</script>

<style scoped>

</style>

